import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ProgressBarComponent } from './components/average-points/progress-bar/progress-bar.component';
import { LeaderboardComponent } from './components/leaderboard/leaderboard.component';
import { RouterModule } from '@angular/router';
import { JokesCardComponent } from './components/jokes-card/jokes-card.component';
import { ProgressBarGameAttendanceComponent } from './components/progress-bar-game-attendance/progress-bar-game-attendance.component';
import { NotificationHubComponent } from './components/notification/notification-hub.component';
import { NotificationCenterToastComponent } from './components/notification/notification-center/toast/notification-center-toast';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NotificationItemComponent } from './components/notification/notification-center/notification-item/notification-item.component';
import { NotificationManagementComponent } from './components/notification/notification-management/notification-management.component';
import { OffersListItemComponent } from './components/offers/offers-list-item/offers-list-item.component';
import { OffersListComponent } from './components/offers/offers-list/offers-list.component';
import { OffersDetailsComponent } from './components/offers/offers-details/offers-details.component';
import { NotificationGroupItemComponent } from './components/notification/notification-management/notification-group-item/notification-group-item.component';
import { OfferTermsModalComponent } from './components/offers/offer-terms-modal/offer-terms-modal.component';
import { PartnersListItemComponent } from './components/offers/partners-list-item/partners-list-item.component';
import { NotificationToastComponent } from './components/notification/notification-center/notification-toast/notification-toast.component';
import { OffersToolbarComponent } from './components/offers/offers-toolbar/offers-toolbar.component';
import { OfferEarnTabComponent } from './components/offers/offer-earn-tab/offer-earn-tab.component';
import { OffersMapComponent } from './components/offers/offers-map/offers-map.component';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ShortLongDescriptionModule } from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { FilterByModule } from '@fgb/portal-component-library/src/lib/shared/filter-by';
import { OfferSearchBarModule } from '@fgb/portal-component-library/src/lib/club/offer-search-bar';
import { LeaderboardMonthlyComponent } from './components/leaderboard-monthly/leaderboard-monthly.component';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { TimeSinceModule } from '@fgb/portal-component-library/src/lib/shared/time-since';
import { NotificationButtonComponent } from './components/notification/notification-button/notification-button.component';
import { NotificationModule } from '@fgb/portal-component-library/src/lib/club/notification';
import { TabComponent } from './components/games-tab/tab.component';
import { CampaignsV2OffersListComponent } from './components/campaigns-v2/campaigns-v2-offers-list/campaigns-v2-offers-list.component';
import { CampaignsV2ListItemComponent } from './components/campaigns-v2/campaigns-v2-list-item/campaigns-v2-list-item.component';
import { CampaignsV2VoucherListItemComponent } from './components/campaigns-v2/campaigns-v2-voucher-list-item/campaigns-v2-voucher-list-item.component';
import { CampaignsV2UsedOffersListComponent } from './components/campaigns-v2/campaigns-v2-used-offers-list/campaigns-v2-used-offers-list.component';
import { CampaignsV2UsedListItemComponent } from './components/campaigns-v2/campaigns-v2-used-list-item/campaigns-v2-used-list-item.component';

@NgModule({
  declarations: [
    ProgressBarComponent,
    LeaderboardComponent,
    JokesCardComponent,
    ProgressBarGameAttendanceComponent,
    NotificationHubComponent,
    NotificationCenterToastComponent,
    NotificationItemComponent,
    NotificationManagementComponent,
    NotificationGroupItemComponent,
    NotificationToastComponent,
    OffersListItemComponent,
    OffersListComponent,
    OffersToolbarComponent,
    OffersMapComponent,
    OfferEarnTabComponent,
    OffersDetailsComponent,
    OfferTermsModalComponent,
    PartnersListItemComponent,
    LeaderboardMonthlyComponent,
    NotificationButtonComponent,
    CampaignsV2OffersListComponent,
    CampaignsV2ListItemComponent,
    CampaignsV2VoucherListItemComponent,
    CampaignsV2UsedOffersListComponent,
    CampaignsV2UsedListItemComponent,
  ],
  imports: [
    NgbModule,
    SharedModule,
    CommonModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ShortLongDescriptionModule,
    OfferSearchBarModule,
    ErrorsModule,
    FilterByModule,
    CountdownModule,
    TimeSinceModule,
    TabComponent,
    ToastrModule.forRoot(),
    InlineSVGModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: function HttpLoaderFactory(http: HttpClient) {
          return new TranslateHttpLoader(http, './assets/i18n/', '.json');
        },
        deps: [HttpClient],
      },
    }),
    RouterModule,
    NotificationModule,
  ],
  exports: [
    ProgressBarComponent,
    LeaderboardComponent,
    JokesCardComponent,
    ProgressBarGameAttendanceComponent,
    NotificationHubComponent,
    NotificationCenterToastComponent,
    NotificationManagementComponent,
    NotificationToastComponent,
    OffersListItemComponent,
    OffersListComponent,
    OffersDetailsComponent,
    OfferTermsModalComponent,
    OffersToolbarComponent,
    OfferEarnTabComponent,
    PartnersListItemComponent,
    LeaderboardMonthlyComponent,
    NotificationButtonComponent,
    CampaignsV2OffersListComponent,
    CampaignsV2ListItemComponent,
    CampaignsV2VoucherListItemComponent,
    CampaignsV2UsedOffersListComponent,
    CampaignsV2UsedListItemComponent,
  ],
})
export class ClubModule {}
